import { Mesh, TextureLoader } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_T3_QueseraV2.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";
import { textureActivityTheme3 } from "../../../../../assets/tema3/activity";

const imgTextureBag = [textureActivityTheme3.topic1.act4.quesera.age2018, textureActivityTheme3.topic1.act4.quesera.age20226]
export class QueseraOperation extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Blitz_maquina = gltf.scene.getObjectByName("Blitz_maquina", true);
			this.Bitz_Tapa_Superior = gltf.scene.getObjectByName("Bitz_Tapa_Superior", true);
			this.Blitz_Tapa_Frontal = gltf.scene.getObjectByName("Blitz_Tapa_Frontal", true);
			this.Quesera_Bolsa = gltf.scene.getObjectByName("Quesera_Bolsa", true);
			this.Bitz_Separador = gltf.scene.getObjectByName("Bitz_Separador", true);
			this.Dispensador = gltf.scene.getObjectByName("Dispensador", true);
			this.Tapon_Bolsa = gltf.scene.getObjectByName("Tapon_Bolsa", true);

			const newMaterialFrontal = this.Blitz_Tapa_Frontal.material.clone();
			newMaterialFrontal.transparent = true
			this.Blitz_Tapa_Frontal.material = newMaterialFrontal;

			const newMaterialBitz_Separador = this.Bitz_Separador.material.clone();
			newMaterialBitz_Separador.transparent = true
			this.Bitz_Separador.material = newMaterialBitz_Separador;

			const newMaterialDispensador = this.Dispensador.material.clone();
			newMaterialDispensador.transparent = true
			this.Dispensador.material = newMaterialDispensador;

			const newMaterialTapon_Bolsa = this.Tapon_Bolsa.material.clone();
			newMaterialTapon_Bolsa.transparent = true
			this.Tapon_Bolsa.material = newMaterialTapon_Bolsa;

			this.onChangueTextureBag(0)

			this.positionObjChild = {
				Blitz_maquina: {
					p: this.Blitz_maquina.position.clone(),
					r: this.Blitz_maquina.rotation.clone()
				},
				Bitz_Tapa_Superior: {
					p: this.Bitz_Tapa_Superior.position.clone(),
					r: this.Bitz_Tapa_Superior.rotation.clone()
				},
				Blitz_Tapa_Frontal: {
					p: this.Blitz_Tapa_Frontal.position.clone(),
					r: this.Blitz_Tapa_Frontal.rotation.clone()
				},
				Quesera_Bolsa: {
					p: this.Quesera_Bolsa.position.clone(),
					r: this.Quesera_Bolsa.rotation.clone()
				},
				Bitz_Separador: {
					p: this.Bitz_Separador.position.clone(),
					r: this.Bitz_Separador.rotation.clone()
				},
				Dispensador: {
					p: this.Dispensador.position.clone(),
					r: this.Dispensador.rotation.clone()
				},
				Tapon_Bolsa: {
					p: this.Tapon_Bolsa.position.clone(),
					r: this.Tapon_Bolsa.rotation.clone()
				},
			}
		});
	}

	setPositionChild() {
		Object.entries(this.positionObjChild).forEach(([key, value]) => {
			this[key].position.copy(value.p)
			this[key].rotation.copy(value.r)
		})
	}

	updateMaterialBag(img) {
		const newTexture = new TextureLoader().load(img);
		this.Quesera_Bolsa.material.map = newTexture
	}

	onChangueTextureBag(type = 0) {
		if (![0, 1].includes(type)) {
			return
		}

		const img = imgTextureBag[type]
		this.updateMaterialBag(img)

	}

	onAnimationMovePosition(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.position,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimationMoveRotation(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.rotation,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onOpacityObject(object, duration = 2, opacity = 0, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.material, {
			opacity,
			duration,
			onComplete: () => {
				callBack()
			},
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Quesera");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("Quesera_Bolsa", this.Quesera_Bolsa);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}


	renderAnimations() { }
}
